const config = {
  API_BASE_URL: 'https://pbs-api-production.up.railway.app',
}
export default config